import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

type CloudBackground = 'show' | 'hide';

interface CloudBackgroundContextProps {
    cloudBackground: CloudBackground;
    hideCloudBackground: (hide: boolean) => void;
}

const CloudBackgroundContext = createContext<CloudBackgroundContextProps | undefined>(undefined);

interface CloudBackgroundProviderProps {
    children: ReactNode;
}

export const CloudBackgroundProvider: React.FC<CloudBackgroundProviderProps> = ({ children }) => {
    const initialMode: CloudBackground = 'show';
    const [cloudBackground, setCloudBackground] = useState<CloudBackground>(initialMode);

    const hideCloudBackground = (hide: boolean) => {
        if (hide)
            setCloudBackground('hide');
        else
            setCloudBackground('show');
    };

    return (
        <CloudBackgroundContext.Provider value={{ cloudBackground, hideCloudBackground }}>
            {children}
        </CloudBackgroundContext.Provider>
    );
};

export const useCloudBackground = () => {
    const context = useContext(CloudBackgroundContext);
    if (!context) {
        throw new Error('useCloudBackground must be used within a CloudBackgroundProvider');
    }
    return context;
}